import React from 'react'

import { SIconSpan } from '../../../common/styles/Icons'

interface IalertIconProps {
    fill?: string
    size?: number
    title?: string
    id?: string
}

const ZapIcon = ({
    fill = 'currentcolor',
    size = 14,
    title,
    id = 'info-icon',
}: IalertIconProps): React.ReactElement => {
    return (
        <SIconSpan title={title} id={id} size={size}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                fill="none"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-zap"
            >
                <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
            </svg>
        </SIconSpan>
    )
}

export default ZapIcon
